// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumb {
    background-color: #f1f1f1;
    padding: 21px 82px;
    color: #717171;
}

.admin-main-content {
    display: flex;
    padding: 20px 40px;
}

.admin-sidebar {
    width: 220px;
    margin-right: 30px;
}

.sidebar-menu {
    margin-bottom: 34px;
}

.sidebar-menu h3 {
    font-size: 18px;
    margin: 0 0 15px 0;
}

.sidebar-menu ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.sidebar-menu ul li {
    padding: 10px 20px;
    cursor: pointer;
    font-size: 14px;
    color: #717171;
}

.sidebar-menu ul li.active {
    color: black;
    font-weight: bold;
}

.admin-content {
    flex-grow: 1;
}
.admin-content .page-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
}

.admin-content .page-title-bar {
    width: 5px;
    height: 24px;
    background-color: #e84118;
}

.admin-content h2 {
    font-size: 24px;
    margin-top: 0;
    margin-bottom: 0px;
}

/* 검색 필터 스타일 */
.customer-search-filters {
    background-color: #f8f9fa;
    border: 1px solid #e0e0e0;
    border-radius: 5px;
    padding: 20px;
    margin-bottom: 30px;
}

.filter-row {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 15px;
}

.filter-row:last-child {
    margin-bottom: 0;
}

.filter-row label {
    font-weight: 600;
    color: #333;
    min-width: 80px;
    font-size: 14px;
}

.filter-select {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    width: 150px;
    font-size: 14px;
}

.filter-input {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    width: 250px;
    font-size: 14px;
}

.date-input {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    width: 150px;
    font-size: 14px;
}

/* 회원 섹션 스타일 */
.customer-section {
    margin-bottom: 40px;
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 2px solid #e84118;
}

.section-header h3 {
    color: #333;
    font-size: 18px;
    font-weight: 600;
    margin: 0;
}

.btn-block-selected {
    background-color: #e84118;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
}

.btn-block-selected:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

.btn-block-selected:not(:disabled):hover {
    background-color: #d63011;
}

/* 테이블 컨테이너 */
.customer-table-container {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 20px;
    background-color: #ffffff;
}

.customer-table {
    width: 100%;
    border-collapse: collapse;
    background-color: #ffffff;
}

.customer-table thead {
    background-color: #f8f9fa;
}

.customer-table thead th {
    padding: 15px 10px;
    text-align: center;
    font-weight: 600;
    color: #333;
    border-bottom: 1px solid #e0e0e0;
    font-size: 14px;
}

.customer-table tbody td {
    padding: 15px 10px;
    text-align: center;
    border-bottom: 1px solid #f0f0f0;
    color: #555;
    font-size: 14px;
    vertical-align: middle;
}

.customer-table tbody tr:hover {
    background-color: #f8f9fa;
}

.customer-table tbody tr:last-child td {
    border-bottom: none;
}

/* 체크박스 스타일 */
.customer-table input[type="checkbox"] {
    width: 16px;
    height: 16px;
    cursor: pointer;
    accent-color: #e84118;
}

/* 액션 버튼 스타일 */
.btn-block {
    background-color: #dc3545;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 3px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
}

.btn-block:hover {
    background-color: #c82333;
}

.btn-unblock {
    background-color: #28a745;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 3px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
}

.btn-unblock:hover {
    background-color: #218838;
}

/* 페이지 액션 버튼 */
.page-actions {
    display: flex;
    justify-content: flex-start;
    margin-top: 30px;
}

.btn-secondary {
    background-color: #6c757d;
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
}

.btn-secondary:hover {
    background-color: #545b62;
}

/* 빈 상태 메시지 */
.empty-state {
    text-align: center;
    padding: 50px;
    color: #666;
    font-size: 16px;
}

/* 반응형 디자인 */
@media (max-width: 1024px) {
    .filter-row {
        flex-wrap: wrap;
    }
    
    .filter-select,
    .filter-input,
    .date-input {
        width: 100%;
        margin-bottom: 10px;
    }
    
    .section-header {
        flex-direction: column;
        gap: 15px;
        align-items: flex-start;
    }
    
    .customer-table-container {
        overflow-x: auto;
    }
    
    .customer-table {
        min-width: 800px;
    }
}

@media (max-width: 768px) {
    .customer-search-filters {
        padding: 15px;
    }
    
    .filter-row {
        flex-direction: column;
        align-items: flex-start;
    }
    
    .filter-row label {
        min-width: auto;
        margin-bottom: 5px;
    }
    
    .customer-table thead {
        display: none;
    }
    
    .customer-table tbody tr {
        display: block;
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        margin-bottom: 15px;
        padding: 15px;
        background-color: #ffffff;
    }
    
    .customer-table tbody td {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 0;
        border-bottom: 1px solid #f0f0f0;
        text-align: left;
    }
    
    .customer-table tbody td:last-child {
        border-bottom: none;
    }
    
    .customer-table tbody td:before {
        content: attr(data-label);
        font-weight: 600;
        color: #333;
        flex: 1 1;
    }
    
    .customer-table tbody td:first-child:before {
        content: "선택";
    }
} `, "",{"version":3,"sources":["webpack://./src/admin/css/BlockedCustomerPage.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,aAAa;IACb,kBAAkB;AACtB;;AAEA,cAAc;AACd;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA,cAAc;AACd;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,aAAa;AACb;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;IAChC,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,aAAa;AACb;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qBAAqB;AACzB;;AAEA,cAAc;AACd;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,cAAc;AACd;IACI,aAAa;IACb,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,aAAa;AACb;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,eAAe;AACnB;;AAEA,YAAY;AACZ;IACI;QACI,eAAe;IACnB;;IAEA;;;QAGI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,kBAAkB;QAClB,mBAAmB;QACnB,aAAa;QACb,yBAAyB;IAC7B;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,cAAc;QACd,gCAAgC;QAChC,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;QACzB,gBAAgB;QAChB,WAAW;QACX,SAAO;IACX;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".breadcrumb {\n    background-color: #f1f1f1;\n    padding: 21px 82px;\n    color: #717171;\n}\n\n.admin-main-content {\n    display: flex;\n    padding: 20px 40px;\n}\n\n.admin-sidebar {\n    width: 220px;\n    margin-right: 30px;\n}\n\n.sidebar-menu {\n    margin-bottom: 34px;\n}\n\n.sidebar-menu h3 {\n    font-size: 18px;\n    margin: 0 0 15px 0;\n}\n\n.sidebar-menu ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.sidebar-menu ul li {\n    padding: 10px 20px;\n    cursor: pointer;\n    font-size: 14px;\n    color: #717171;\n}\n\n.sidebar-menu ul li.active {\n    color: black;\n    font-weight: bold;\n}\n\n.admin-content {\n    flex-grow: 1;\n}\n.admin-content .page-header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 20px;\n}\n\n.admin-content .page-title-bar {\n    width: 5px;\n    height: 24px;\n    background-color: #e84118;\n}\n\n.admin-content h2 {\n    font-size: 24px;\n    margin-top: 0;\n    margin-bottom: 0px;\n}\n\n/* 검색 필터 스타일 */\n.customer-search-filters {\n    background-color: #f8f9fa;\n    border: 1px solid #e0e0e0;\n    border-radius: 5px;\n    padding: 20px;\n    margin-bottom: 30px;\n}\n\n.filter-row {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    margin-bottom: 15px;\n}\n\n.filter-row:last-child {\n    margin-bottom: 0;\n}\n\n.filter-row label {\n    font-weight: 600;\n    color: #333;\n    min-width: 80px;\n    font-size: 14px;\n}\n\n.filter-select {\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    width: 150px;\n    font-size: 14px;\n}\n\n.filter-input {\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    width: 250px;\n    font-size: 14px;\n}\n\n.date-input {\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    width: 150px;\n    font-size: 14px;\n}\n\n/* 회원 섹션 스타일 */\n.customer-section {\n    margin-bottom: 40px;\n}\n\n.section-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n    padding-bottom: 15px;\n    border-bottom: 2px solid #e84118;\n}\n\n.section-header h3 {\n    color: #333;\n    font-size: 18px;\n    font-weight: 600;\n    margin: 0;\n}\n\n.btn-block-selected {\n    background-color: #e84118;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.btn-block-selected:disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n}\n\n.btn-block-selected:not(:disabled):hover {\n    background-color: #d63011;\n}\n\n/* 테이블 컨테이너 */\n.customer-table-container {\n    border: 1px solid #e0e0e0;\n    border-radius: 4px;\n    overflow: hidden;\n    margin-bottom: 20px;\n    background-color: #ffffff;\n}\n\n.customer-table {\n    width: 100%;\n    border-collapse: collapse;\n    background-color: #ffffff;\n}\n\n.customer-table thead {\n    background-color: #f8f9fa;\n}\n\n.customer-table thead th {\n    padding: 15px 10px;\n    text-align: center;\n    font-weight: 600;\n    color: #333;\n    border-bottom: 1px solid #e0e0e0;\n    font-size: 14px;\n}\n\n.customer-table tbody td {\n    padding: 15px 10px;\n    text-align: center;\n    border-bottom: 1px solid #f0f0f0;\n    color: #555;\n    font-size: 14px;\n    vertical-align: middle;\n}\n\n.customer-table tbody tr:hover {\n    background-color: #f8f9fa;\n}\n\n.customer-table tbody tr:last-child td {\n    border-bottom: none;\n}\n\n/* 체크박스 스타일 */\n.customer-table input[type=\"checkbox\"] {\n    width: 16px;\n    height: 16px;\n    cursor: pointer;\n    accent-color: #e84118;\n}\n\n/* 액션 버튼 스타일 */\n.btn-block {\n    background-color: #dc3545;\n    color: white;\n    border: none;\n    padding: 6px 12px;\n    border-radius: 3px;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 500;\n}\n\n.btn-block:hover {\n    background-color: #c82333;\n}\n\n.btn-unblock {\n    background-color: #28a745;\n    color: white;\n    border: none;\n    padding: 6px 12px;\n    border-radius: 3px;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 500;\n}\n\n.btn-unblock:hover {\n    background-color: #218838;\n}\n\n/* 페이지 액션 버튼 */\n.page-actions {\n    display: flex;\n    justify-content: flex-start;\n    margin-top: 30px;\n}\n\n.btn-secondary {\n    background-color: #6c757d;\n    color: white;\n    border: none;\n    padding: 12px 24px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.btn-secondary:hover {\n    background-color: #545b62;\n}\n\n/* 빈 상태 메시지 */\n.empty-state {\n    text-align: center;\n    padding: 50px;\n    color: #666;\n    font-size: 16px;\n}\n\n/* 반응형 디자인 */\n@media (max-width: 1024px) {\n    .filter-row {\n        flex-wrap: wrap;\n    }\n    \n    .filter-select,\n    .filter-input,\n    .date-input {\n        width: 100%;\n        margin-bottom: 10px;\n    }\n    \n    .section-header {\n        flex-direction: column;\n        gap: 15px;\n        align-items: flex-start;\n    }\n    \n    .customer-table-container {\n        overflow-x: auto;\n    }\n    \n    .customer-table {\n        min-width: 800px;\n    }\n}\n\n@media (max-width: 768px) {\n    .customer-search-filters {\n        padding: 15px;\n    }\n    \n    .filter-row {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n    \n    .filter-row label {\n        min-width: auto;\n        margin-bottom: 5px;\n    }\n    \n    .customer-table thead {\n        display: none;\n    }\n    \n    .customer-table tbody tr {\n        display: block;\n        border: 1px solid #e0e0e0;\n        border-radius: 4px;\n        margin-bottom: 15px;\n        padding: 15px;\n        background-color: #ffffff;\n    }\n    \n    .customer-table tbody td {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 8px 0;\n        border-bottom: 1px solid #f0f0f0;\n        text-align: left;\n    }\n    \n    .customer-table tbody td:last-child {\n        border-bottom: none;\n    }\n    \n    .customer-table tbody td:before {\n        content: attr(data-label);\n        font-weight: 600;\n        color: #333;\n        flex: 1;\n    }\n    \n    .customer-table tbody td:first-child:before {\n        content: \"선택\";\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
